/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import style from './uploadArea.module.scss';
import Button from 'controls/buttons/submit';
import AddImageIcon from 'icons/addImage';
import { useFileList } from 'hooks/files/useFileList';
import isEmpty from 'lodash-es/isEmpty';
import { useAppDispatch } from 'store/hooks';
import { setUploadedFiles } from 'store/transitionSlice';
import { UploadItems } from 'store/types';
import DropCircle from 'components/dropCircle/dropCircle';
import ReactDOM from 'react-dom';

export type UploadAreaProps = {
  onClose: () => void;
  onUpload?: (items: UploadItems) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDrop?: (e: React.DragEvent) => void;
  setter?: typeof setUploadedFiles;
  isMultiple?: boolean;
  disableSetter?: boolean;
  accept?: string;
};

export default function UploadArea({
  onClose,
  onUpload,
  onChange,
  onDrop,
  setter = setUploadedFiles,
  isMultiple = true,
  disableSetter = false,
  accept = 'image/*',
}: UploadAreaProps) {
  const inputFileRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();
  const { list, onDrop: localOnDrop, onBrowse, loading } = useFileList();
  const [isHover, setIsHover] = useState(false);
  const [mouseCoordinates, setMouseCoordinates] = useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    if (!isEmpty(list) && isEmpty(loading)) {
      !disableSetter && dispatch(setter(list));
      onClose();
      onUpload && onUpload(list);
    }
  }, [list, loading]);

  return (
    <div
      className={style.container}
      onDrop={(e) => {
        onDrop && onDrop(e);
        localOnDrop(e);
      }}
      onDragEnter={(e) => {
        e.stopPropagation();
        e.preventDefault();

        setIsHover(true);
      }}
      onDragOver={(e) => {
        e.stopPropagation();
        e.preventDefault();

        setMouseCoordinates({
          x: e.pageX,
          y: e.pageY,
        });
      }}
      onDragLeave={(e) => {
        e.stopPropagation();
        e.preventDefault();

        setIsHover(false);
      }}
    >
      {isHover ? (
        ''
      ) : (
        <>
          <AddImageIcon className={style.icon}></AddImageIcon>
          <span>Контент отсутствует</span>
          <span>Перетащите одно или несколько изображений сюда</span>
          <div className={style.upload}>
            <Button
              startIcon={<AddImageIcon />}
              onClick={() => inputFileRef?.current?.click()}
            >
              Загрузить
            </Button>
          </div>
        </>
      )}
      <input
        className={'hidden'}
        type="file"
        accept={accept}
        ref={inputFileRef}
        multiple={isMultiple}
        onChange={(e) => {
          onChange && onChange(e);
          onBrowse(e);
        }}
      />
      {ReactDOM.createPortal(
        <DropCircle isVisible={isHover} {...mouseCoordinates}></DropCircle>,
        document.body
      )}
    </div>
  );
}
